<div class="max-w-screen-xl p-6 mx-auto bg-white shadow-md rounded-xl">
  <h2 class="mb-6 text-2xl font-medium text-gray-800">
    Créer une Carte d'inspection
  </h2>

  <div class="grid grid-cols-3 gap-8">
    <form class="grid grid-cols-3 col-span-3 gap-6">

      <!-- Champ Rapport Inspection -->
      <div>
        <div class="flex items-center">
          <label for="fonctionnementEtat" class="block mb-2 text-sm font-medium text-gray-800">
            Rapport Inspection
          </label>
          <span class="ml-1 text-red-500">*</span>
        </div>

        <select id="fonctionnementEtat" name="etatFonctionnement" [(ngModel)]="badge.certificatControl.id"
          (ngModelChange)="saveForm()"
          class="bg-gray-50 border border-gray-800 text-gray-800 text-sm rounded-lg focus:ring-gray-500 focus:border-gray-500 block w-full p-2.5"
          required>
          <option>Sélectionnez un Rapport d'inspection</option>
          <option [value]="rapport.id" *ngFor="let rapport of certificatControls">
            {{ rapport.vehicule?.numeroAssurance }} - {{ rapport.creationDate }}
          </option>
        </select>
      </div>

      <!-- Champ Numéro du Parc -->
      <div>
        <div class="flex items-center">
          <label for="numeroImmatriculation" class="block mb-2 text-sm font-medium text-gray-800">
            Numéro d'immatriculation
          </label>
          <span class="ml-1 text-red-500">*</span>
        </div>

        <input type="text" id="numeroRapport" placeholder="Numéro d'immatriculation" name="numeroImmatriculation"
          [(ngModel)]="badge.numeroParc" (ngModelChange)="saveForm()"
          class="bg-gray-50 border border-gray-800 text-gray-800 text-sm rounded-lg focus:ring-gray-500 focus:border-gray-500 block w-full p-2.5" />
      </div>

      <!-- Champ Validité -->
      <div>
        <div class="flex items-center">
          <label for="validite" class="block mb-2 text-sm font-medium text-gray-800">
            Validité
          </label>
          <span class="ml-1 text-red-500">*</span>
        </div>

        <select id="validite" name="validite" [(ngModel)]="badge.validite" (ngModelChange)="saveForm()"
          class="bg-gray-50 border border-gray-800 text-gray-800 text-sm rounded-lg focus:ring-gray-500 focus:border-gray-500 block w-full p-2.5"
          required>
          <option value>Sélectionnez une Validité</option>
          <option *ngFor="let mois of moisOptions" [value]="mois.value">
            {{ mois.label }}
          </option>
        </select>
      </div>

      <!-- Bouton Enregistrer -->
      <div class="flex justify-end col-start-3">
        <button type="button" (click)="save()"
          class="mt-4 flex items-center gap-2 text-white bg-gray-600 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-6 py-2.5 text-center">
          {{ origin }}
        </button>
      </div>
    </form>
  </div>
</div>